import { useEffect } from 'react'
import { useCookieConsent } from 'react-cookie-manager'

import { getLocalStorage } from '../hooks/appVariables'
import useStore from '../store'

const ZOOM_WEBCHAT_SCRIPT_ID = 'zoom-zcc-sdk'
const ZOOM_WEBCHAT_SRC = 'https://us01ccistatic.zoom.us/us01cci/web-sdk/zcc-sdk.js'

const readLocalStorage = (key) => {
  try {
    return getLocalStorage(key)
  } catch {
    return null
  }
}

const ZoomWebchat = () => {
  const { detailedConsent } = useCookieConsent()
  const hasSocialConsent = detailedConsent?.Social?.consented === true
  const apiKey = process.env.REACT_APP_ZOOM_WEBCHAT_API_KEY || process.env.REACT_APP_ZOOM_API_KEY
  const zoomEnvironment = process.env.REACT_APP_ZOOM_WEBCHAT_ENV || 'us01'

  const userFromStore = useStore((state) => state.user)
  const emailFromStore = useStore((state) => state.email)

  const currentUser = readLocalStorage(process.env.REACT_APP_USER_KEY)
  const selectedCompany = readLocalStorage(process.env.REACT_APP_COMPANY_KEY)

  const userEmail = (currentUser?.emailAddress || userFromStore?.emailAddress || emailFromStore || '').trim()
  const firstName = (currentUser?.firstName || userFromStore?.firstName || '').trim()
  const lastName = (currentUser?.lastName || userFromStore?.lastName || '').trim()
  const companyName = (selectedCompany?.name || selectedCompany?.companyName || '').trim()

  useEffect(() => {
    if (!apiKey || !hasSocialConsent) {
      return
    }

    if (process.env.NODE_ENV !== 'production') {
      console.log('[ZoomWebchat] visitor context', {
        userEmail,
        firstName,
        lastName,
        companyName,
        zoomEnvironment
      })
    }

    const existingScript = document.getElementById(ZOOM_WEBCHAT_SCRIPT_ID)
    if (existingScript) {
      existingScript.remove()
    }

    const sdkScript = document.createElement('script')
    sdkScript.id = ZOOM_WEBCHAT_SCRIPT_ID
    sdkScript.type = 'module'
    sdkScript.src = ZOOM_WEBCHAT_SRC
    sdkScript.setAttribute('data-apikey', apiKey)
    sdkScript.setAttribute('data-env', zoomEnvironment)
    if (userEmail) {
      sdkScript.setAttribute('data-user-email', userEmail)
    }
    if (firstName) {
      sdkScript.setAttribute('data-first-name', firstName)
    }
    if (lastName) {
      sdkScript.setAttribute('data-last-name', lastName)
    }
    if (companyName) {
      sdkScript.setAttribute('data-company-name', companyName)
    }

    document.body.appendChild(sdkScript)
  }, [apiKey, hasSocialConsent, zoomEnvironment, userEmail, firstName, lastName, companyName])

  return null
}

export default ZoomWebchat
